import React from 'react';
import '../Library/Library.css'; // library-sr-only

/* Every labelled field says whether it's required or optional (ResUI Design
   Decisions, Component states), as Add scenario's fields do. */
export const Required = () => (
  <>
    <span className="resui-field-required" aria-hidden="true">*</span>
    <span className="library-sr-only">required</span>
  </>
);

export const Optional = () => <span className="resui-field-optional">(optional)</span>;
